<textarea class="html-editor" [ngModel]="html" (ngModelChange)="htmlChange.emit($event)" spellcheck="false"></textarea>
